// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__QdZ0B","social":"socials__social__LAo5E","icon":"socials__icon__DsPvq","navOpen":"socials__navOpen__eaYeT"};